module.exports = __webpack_public_path__ + "img/screen4.7f3a1642.png";